import { render, staticRenderFns } from "./PageResetPassword.vue?vue&type=template&id=bb675aa8&scoped=true&"
import script from "./PageResetPassword.vue?vue&type=script&lang=js&"
export * from "./PageResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb675aa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb675aa8')) {
      api.createRecord('bb675aa8', component.options)
    } else {
      api.reload('bb675aa8', component.options)
    }
    module.hot.accept("./PageResetPassword.vue?vue&type=template&id=bb675aa8&scoped=true&", function () {
      api.rerender('bb675aa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/forgotpassword/PageResetPassword.vue"
export default component.exports